import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';

// Providers-Services
import { ApiRestService } from '../../services/shared/api-rest.service';

@Injectable({
  providedIn: 'root'
})
export class SendEmailService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService
  ) { }

  // Enviar Email
  public sendEmail(tmpl, listaEmail, subj, text, adjunto?, cc?) {
    if (adjunto === undefined) {
      adjunto = [];
    }

    if (cc === undefined) {
      cc = [];
    }
    // tslint:disable: max-line-length
    // console.log(this._apiRestService.APIURL.serv9995 + `/{"tmpl":"${tmpl}","mail":${JSON.stringify(listaEmail)},"subj":${JSON.stringify(subj)},"text":${JSON.stringify(text)},"cc":${JSON.stringify(cc)},"file":${JSON.stringify(adjunto)}}`);
    return this.http.get(this._apiRestService.APIURL.serv9995 + `/{"tmpl":"${tmpl}","mail":${JSON.stringify(listaEmail)},"subj":${JSON.stringify(subj)},"text":${JSON.stringify(text)},"cc":${JSON.stringify(cc)},"file":${JSON.stringify(adjunto)}}`
    ).pipe(map
      ((res: any) => {
        return res;
      }),
      catchError(err => {
        return throwError(err);
      }));
  }
}
